import { render, staticRenderFns } from "./CustomersSyncErpModal.vue?vue&type=template&id=a295e9b8"
import script from "./CustomersSyncErpModal.vue?vue&type=script&lang=js"
export * from "./CustomersSyncErpModal.vue?vue&type=script&lang=js"
import style0 from "./CustomersSyncErpModal.vue?vue&type=style&index=0&id=a295e9b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports